import React from 'react';
import PropTypes from 'prop-types';
import {Consumer as StyleFrameworkConsumer} from './style-framework';

export default function WrappedActiveBrand(props) {
  return (
    <StyleFrameworkConsumer>
      {({brands}) => {
        const {activeBrand, ...rest} = brands;
        const isAnyWayfair = [
          brands.WAYFAIR,
          brands.WAYFAIR_CA,
          brands.WAYFAIR_DE,
          brands.WAYFAIR_UK,
        ].includes(activeBrand);
        return props.children({
          ...rest,
          // Legacy code still refers to the active brand as simply `brand`
          // So we preserve the name here
          brand: activeBrand,
          isAnyWayfair,
        });
      }}
    </StyleFrameworkConsumer>
  );
}
WrappedActiveBrand.propTypes = {
  children: PropTypes.func.isRequired,
};
